import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const OrdinaryOfferingAmountInput = forwardRef(
  ({ loading, onChange, onBlur, name, minimalValue }, ref) => {
    return (
      <div className="md-form input-group mt-0 mb-0">
        <input
          className="form-control"
          disabled={loading}
          inputMode="numeric"
          name={name}
          onBlur={onBlur}
          onChange={event => onChange(parseFloat(event.target.value.replace(',', '.')) || 0)}
          pattern="[0-9]+([.,][0-9]{0,2})?"
          ref={ref}
          step="1"
          type="number"
          min={minimalValue}
        />
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label htmlFor="death_prayers_form_amount">Ofiara</label>
        <div className="input-group-append">
          <span className="input-group-text md-addon">PLN</span>
        </div>
      </div>
    );
  },
);

OrdinaryOfferingAmountInput.propTypes = {
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  minimalValue: PropTypes.number,
};

export default OrdinaryOfferingAmountInput;
